module.exports = __webpack_public_path__ + "img/code-build.34f22d2b.png";